<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'styleSelector',
})
</script>
<template>
    <div @click="open" style="border-radius:3px;background-size: contain!important;" class="flex  bg-gray text-white align-center justify-center pointer" :style="{width:size+'px',height:size+'px','background-image':'url('+addip('/img/style/'+props.value+'.jpg')+')'}">
       <span  style="z-index: 1;">{{props.value}}</span>
       <a-modal @ok="submit" v-model:open="opend" width="80%" title="选择内容组件">
          <a-row>
            <a-col :span="6" v-for="(item,i) in dataSource" :key="i">
              <div  class="padding flex-cloumn style-box " :class="item.classname==def?'bg-primary box-shadow':''" @click="toChange(item.classname)">
                <img :src="addip(item.pic)"  />
                <div class="padding-sm text-center">
                  <p> {{item.title}}</p>
                  <p >  {{item.classname}}</p>
                </div>
              </div>
            </a-col>
          </a-row>
          <div  class="padding">
              <a-pagination v-model:current="pages.pageIndex" v-model:pageSize="pages.pageSize" :total="pages.records" show-less-items @change="pageChange" />
          </div>
        </a-modal>
    </div>
</template>
<script setup name="styleSelector" lang="ts">
import { onMounted,defineProps,ref,reactive,defineEmits,defineExpose ,onUpdated} from 'vue';
import {PlusOutlined,CaretRightOutlined} from '@ant-design/icons-vue';
import api from '@/utils/http/service'
import {addip} from '@/utils/util'

const emit=defineEmits(['update:value'])
const props=defineProps({
  value:{type:String,default:'default'},
  size:{type:Number,default:100}
})
const def=ref<String>("")
const pages=reactive<Object>({
    pageIndex:1,
    pageSize:8,
    records:0
})
const opend=ref<Boolean>(false)
const dataSource=ref<Array>([])
onMounted(()=>{
  def.value=props.value
  getData()
})
const toChange=(e)=>{
  def.value=e
}
const open=(classname:String)=>{
  opend.value=true
}
const close=()=>{
  opend.value=false
}
const getData=()=>{
  api.sitepage.styles(pages).then(res=>{
    dataSource.value=res.data.data
    pages.pageIndex=res.data.pageIndex
    pages.pageSize=res.data.pageSize
    pages.records=res.data.records
  })
}
const pageChange=(page:Number,pageSize:Number)=>{
  pages.pageIndex=page
  pages.pageSize=pageSize
  getData()
}
const submit=()=>{
  emit('update:value',def.value)
  opend.value=false
}

defineExpose({
  open,close
})
</script>
<style>
.style-box img{width:100%;height:auto;cursor: pointer;}
</style>
